<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header" style="align-items: center;">
          <div *ngIf="isLoggedIn" class="row">
            <div class="col-md-auto">
              <h1> {{title}} </h1>
            </div>
          </div>
        </div>
        <div class="comparator card-body tab2-card">
          <div class="row">
            <div class="col-sm shadow p-3 mb-5 bg-white rounded">
              <div class="col">
                <a href="{{userGuideLink}}" target="_blank">
                  <i class="fa fa-info-circle" aria-hidden="true"></i> {{applicationUserGuide}}
                </a>
              </div>
              <div class="col">
                <a href="{{userTutorialLink}}" target="_blank">
                  <i class="fa fa-video-camera" aria-hidden="true"></i> {{applicationTutorial}}
                </a>
              </div>
            </div>
            <div class="col-sm" *ngIf="isComparatorSwitchVisible">
              <div class="center-item">
                <div ngbDropdown placement="bottom" class="d-inline-block dropdown">
                  <button ngbDropdownToggle class="btn btn-primary responsiveButton" type="button"
                    id="dropdownMenuButton" aria-expanded="false">
                    {{title}}
                  </button>
                  <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                    <li><a ngbDropdownItem class="responsiveButton" [routerLink]="['/comparator']"
                        [queryParams]="{comparatorType: 'gas'}">{{naturalGasSupplyComparison}}</a></li>
                    <li><a ngbDropdownItem class="responsiveButton" [routerLink]="['/comparator']"
                        [queryParams]="{comparatorType: 'electric'}">{{naturalElectricitySupplyComparison}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!--<div class="alert alert-danger" role="alert">
            Vă informam că în perioada următoare asupra Comparatorului de oferte tip de energie electrica si gaze naturale se realizează lucrări de  mentenanță. Ne cerem scuze pentru disconfortul creat. Revenim în cel mai scurt timp cu putință. Vă mulțumim pentru înțelegere.
          </div>-->

          <form [formGroup]="comparatorForm" class="needs-validation" novalidate>
            <h5 class="bold" *ngIf="isNaturalGasSupplyComparisonForm">{{mandatoryCriteriaLabel}}</h5>
            <div class="form-group row mt-4">
              <ng-container
                *ngFor="let mandatoryCriteria of mandatoryCriteriaInputs | keyvalue: originalOrder; let i =index">
                <div class="col-xl-4 col-sm-4 mb-3">
                  <label class="bold" [ngClass]="onDisplayLabelCss(controlFormNameMap.get(mandatoryCriteria.key))">
                    <ng-container [ngSwitch]="mandatoryCriteria.key">
                      <ng-container *ngSwitchCase="'DAY_CONSUMPTION_PERCENTAGE'">
                        <ng-container *ngIf="isConsumptionPercentageDisplayed">
                          {{mandatoryCriteria.value}}
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'NIGHT_CONSUMPTION_PERCENTAGE'">
                        <ng-container *ngIf="isConsumptionPercentageDisplayed">
                          {{mandatoryCriteria.value}}
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        {{mandatoryCriteria.value}}
                      </ng-container>
                    </ng-container>

                    <ng-container [ngSwitch]="mandatoryCriteria.key">
                      <ng-container *ngSwitchCase="'CURRENT_INVOICE_VALUE'">
                      </ng-container>
                      <ng-container *ngSwitchCase="'CURRENT_BILL_CONSUMPTION'">
                      </ng-container>
                      <ng-container *ngSwitchCase="'DAY_CONSUMPTION_PERCENTAGE'">
                        <ng-container *ngIf="isConsumptionPercentageDisplayed">
                          <span>*</span>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchCase="'NIGHT_CONSUMPTION_PERCENTAGE'">
                        <ng-container *ngIf="isConsumptionPercentageDisplayed">
                          <span>*</span>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <span>*</span>
                      </ng-container>
                    </ng-container>
                    <div class="prelative" *ngIf="templateNameMap.get(mandatoryCriteria.key)">
                      <a (mouseover)="onCriteriaInfoMouseOver(mandatoryCriteriaTemplate,i)"
                        (mouseleave)="onCriteriaInfoMouseLeave(mandatoryCriteriaTemplate)" aria-hidden="true">
                        <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                      </a>
                      <div #mandatoryCriteriaTemplate class="comparatorToolTip" style="display: none;">
                        <ng-container *ngTemplateOutlet='templateNameMap.get(mandatoryCriteria.key)'></ng-container>
                      </div>
                    </div>
                  </label>

                  <ng-container [ngSwitch]="mandatoryCriteria.key">
                    <ng-container *ngSwitchCase="'FINAL_CLIENT_TYPE'">
                      <select class="form-control digits"
                        [ngClass]="onDisplayFieldCss(controlFormNameMap.get(mandatoryCriteria.key))"
                        formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" required>
                        <option [value]="option" *ngFor="let option of options[mandatoryCriteria.key]">{{option}}
                        </option>
                      </select>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CONNECTION_METHOD'">
                      <select class="form-control digits" (change)="onChangeConnectionMethod($event.target.value)"
                        [ngClass]="onDisplayFieldCss(controlFormNameMap.get(mandatoryCriteria.key))"
                        formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" required>
                        <option [value]="option" *ngFor="let option of options[mandatoryCriteria.key]">{{option}}
                        </option>
                      </select>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CURRENT_BILL_CONSUMPTION'">
                      <input class="form-control" type="number"
                        formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'DAY_CONSUMPTION_PERCENTAGE'">
                      <ng-container *ngIf="isConsumptionPercentageDisplayed">
                        <input class="form-control" type="number"
                          [ngClass]="onDisplayFieldCss(controlFormNameMap.get(mandatoryCriteria.key))"
                          placeholder={{electricitySupplyMandatoryCriteriaInputs.DAY_CONSUMPTION_PERCENTAGE}}
                          formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" />
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'NIGHT_CONSUMPTION_PERCENTAGE'">
                      <ng-container *ngIf="isConsumptionPercentageDisplayed">
                        <input class="form-control" type="number"
                          [ngClass]="onDisplayFieldCss(controlFormNameMap.get(mandatoryCriteria.key))"
                          placeholder={{electricitySupplyMandatoryCriteriaInputs.NIGHT_CONSUMPTION_PERCENTAGE}}
                          formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" />
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CURRENT_INVOICE_VALUE'">
                      <input class="form-control" type="number"
                        formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'OFFER_DATE'">
                      <input class="form-control" [min]="minDate | date:'yyyy-MM-dd'"
                        [ngClass]="onDisplayFieldCss(controlFormNameMap.get(mandatoryCriteria.key))" type="date"
                        formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" onkeydown="return false"
                        required />
                    </ng-container>
                    <ng-container *ngSwitchCase="'COUNTY'">
                      <select class="form-control digits"
                        [ngClass]="onDisplayFieldCss(controlFormNameMap.get(mandatoryCriteria.key))"
                        (change)="onGetCitiesByCounty($event.target.value)"
                        formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" required>
                        <option value disabled selected hidden>Județ</option>
                        <ng-container *ngIf="isNaturalGasSupplyComparisonForm">
                          <option *ngFor="let county of countiesGas" [value]="county.id_judet">{{county.nume}}
                          </option>
                        </ng-container>
                        <ng-container *ngIf="isNaturalElectricitySupplyComparisonForm">
                          <option *ngFor="let county of countiesElectricity" [value]="county.id_judet">
                            {{county.nume}}</option>
                        </ng-container>
                      </select>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CITY'">
                      <select class="form-control digits"
                        [ngClass]="onDisplayFieldCss(controlFormNameMap.get(mandatoryCriteria.key))"
                        formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" required>
                        <option value disabled selected hidden>Localitate</option>
                        <option *ngFor="let city of cities" [value]="city.siruta">
                          {{city.localitate_apartinatoare}} ({{city.localitate_principala}})</option>
                      </select>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <select class="form-control digits"
                        [ngClass]="onDisplayFieldCss(controlFormNameMap.get(mandatoryCriteria.key))"
                        formControlName="{{controlFormNameMap.get(mandatoryCriteria.key)}}" required>
                        <option [value]="option" *ngFor="let option of options[mandatoryCriteria.key]">{{option}}
                        </option>
                      </select>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>
            <hr>
            <h5 class="bold pt-5">{{additionalCriteria}}
              <div class="prelative">
                <a (mouseover)="onCriteriaInfoMouseOver(mandatoryCriteriaTemplate, 0)"
                  (mouseleave)="onCriteriaInfoMouseLeave(mandatoryCriteriaTemplate)" aria-hidden="true">
                  <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                </a>
                <div #mandatoryCriteriaTemplate class="comparatorToolTip" style="display: none;">
                  <ng-container *ngTemplateOutlet="templateNameMap.get('ADDITIONAL_CRITERIA')"></ng-container>
                </div>
              </div>
            </h5>
            <div class="form-group row mt-4">
              <ng-container
                *ngFor="let additionalCriteria of additionalCriteriaInputs | keyvalue: originalOrder; let i =index">
                <div class="col-xl-4 col-sm-4 mb-3">
                  <label class="bold" [ngClass]="onDisplayLabelCss(controlFormNameMap.get(additionalCriteria.key))">
                    {{additionalCriteria.value}}
                    <div class="prelative" *ngIf="templateNameMap.get(additionalCriteria.key)">
                      <ng-container [ngSwitch]="additionalCriteria.key">
                        <ng-container *ngSwitchCase="'OFFER_TYPE'">
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                          <a (mouseover)="onCriteriaInfoMouseOver(additionalCriteriaTemplate,i)"
                            (mouseleave)="onCriteriaInfoMouseLeave(additionalCriteriaTemplate)" aria-hidden="true">
                            <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                          </a>
                          <div #additionalCriteriaTemplate class="comparatorToolTip" style="display: none;">
                            <ng-container *ngTemplateOutlet='templateNameMap.get(additionalCriteria.key)'>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </label>

                  <ng-container [ngSwitch]="additionalCriteria.key">
                    <ng-container *ngSwitchCase="'OFFER_DATE'">
                      <input class="form-control" type="date" [min]="minDate | date:'yyyy-MM-dd'"
                        formControlName="{{controlFormNameMap.get(additionalCriteria.key)}}" onkeydown="return false" />
                    </ng-container>
                    <ng-container *ngSwitchCase="'PAYMENT_TERM'">
                      <select class="form-control digits"
                        [ngClass]="onDisplayFieldCss(controlFormNameMap.get(additionalCriteria.key))"
                        formControlName="{{controlFormNameMap.get(additionalCriteria.key)}}" required>
                        <option [value]="option" *ngFor="let option of options[additionalCriteria.key]">{{option}}
                        </option>
                      </select>
                    </ng-container>
                    <ng-container *ngSwitchCase="'OFFER_TYPE'">
                      <div class="row mb-1" *ngFor=" let option of options['OFFER_TYPE']; let optionNumber = index">
                        <span class="d-block"
                          [ngClass]="onDisplayLabelCss(controlFormNameMap.get(additionalCriteria.key))">
                          <input class="checkbox_animated" [value]="option" type="radio" name="offerType"
                            [formControlName]="controlFormNameMap.get(additionalCriteria.key)">
                          {{option}}
                          <div class="prelative" *ngIf="templateNameMap.get('offerTypeOption'+ optionNumber)">
                            <a (mouseover)="onCriteriaInfoMouseOver(additionalCriteriaTemplate,i)"
                              (mouseleave)="onCriteriaInfoMouseLeave(additionalCriteriaTemplate)" aria-hidden="true">
                              <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                            </a>
                            <div #additionalCriteriaTemplate class="comparatorToolTip" style="display: none;">
                              <ng-container *ngTemplateOutlet="templateNameMap.get('offerTypeOption'+ optionNumber)">
                              </ng-container>
                            </div>
                          </div>
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'GAS_PRICE_TYPE'">
                      <div class="row mb-1" *ngFor=" let option of options['GAS_PRICE_TYPE']; let optionNumber = index">
                        <span class="d-block"
                          [ngClass]="onDisplayLabelCss(controlFormNameMap.get(additionalCriteria.key))">
                          <input class="checkbox_animated" [value]="option" type="radio" name="gasPriceType"
                            [formControlName]="controlFormNameMap.get(additionalCriteria.key)">
                          {{option}}
                          <div class="prelative" *ngIf="templateNameMap.get('gasPriceTypeOption'+ optionNumber)">
                            <a (mouseover)="onCriteriaInfoMouseOver(additionalCriteriaTemplate,i)"
                              (mouseleave)="onCriteriaInfoMouseLeave(additionalCriteriaTemplate)" aria-hidden="true">
                              <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                            </a>
                            <div #additionalCriteriaTemplate class="comparatorToolTip" style="display: none;">
                              <ng-container *ngTemplateOutlet="templateNameMap.get('gasPriceTypeOption'+ optionNumber)">
                              </ng-container>
                            </div>
                          </div>
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'CONVENTION'">
                      <ng-container *ngIf="isNaturalGasSupplyComparisonForm">
                        <div class="row mb-1" *ngFor=" let option of options['CONVENTION']; let optionNumber = index">
                          <span class="d-block"
                            [ngClass]="onDisplayLabelCss(controlFormNameMap.get(additionalCriteria.key))">
                            <input class="checkbox_animated"
                              [checked]=" gasSelectedConventions.includes(option) ?? false" [value]="option"
                              type="checkbox" name="convention"
                              (change)="onCheckboxChange($event, controlFormNameMap.get(additionalCriteria.key))">
                            {{option}}
                          </span>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="isNaturalElectricitySupplyComparisonForm">
                        <select class="form-control digits"
                          [ngClass]="onDisplayFieldCss(controlFormNameMap.get(additionalCriteria.key))"
                          formControlName="{{controlFormNameMap.get(additionalCriteria.key)}}" required>
                          <option [value]="option" *ngFor="let option of options[additionalCriteria.key]">{{option}}
                          </option>
                        </select>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <select class="form-control digits"
                        formControlName="{{controlFormNameMap.get(additionalCriteria.key)}}">
                        <option [value]="option" *ngFor="let option of options[additionalCriteria.key]">{{option}}
                        </option>
                      </select>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </div>

            <ng-container *ngIf="isNaturalGasSupplyComparisonForm">
              <h5 class="bold">{{comparisonInformation}}
                <div class="prelative">
                  <a (mouseover)="onCriteriaInfoMouseOver(additionalCriteriaTemplate,0)"
                    (mouseleave)="onCriteriaInfoMouseLeave(additionalCriteriaTemplate)" aria-hidden="true">
                    <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                  </a>
                  <div #additionalCriteriaTemplate class="comparatorToolTip" style="display: none;">
                    <ng-container *ngTemplateOutlet="templateNameMap.get('COMPARISON_INFORMATION')">
                    </ng-container>
                  </div>
                </div>
              </h5>
              <div class="form-group row mt-4">
                <ng-container
                  *ngFor="let informationCriteria of naturalGasSupplyComparisonInformationCriteriaInputs | keyvalue: originalOrder; let i =index">
                  <div class="col-xl-4 col-sm-4 mb-3">
                    <label class="bold">{{informationCriteria.value}}
                      <div class="prelative" *ngIf="templateNameMap.get(informationCriteria.key)">
                        <a (mouseover)="onCriteriaInfoMouseOver(informationCriteriaTemplate,i)"
                          (mouseleave)="onCriteriaInfoMouseLeave(informationCriteriaTemplate)" aria-hidden="true">
                          <img class="pb-2" src="../../../../assets/images/info.png" width="16">
                        </a>
                        <div #informationCriteriaTemplate class="comparatorToolTip" style="display: none;">
                          <ng-container *ngTemplateOutlet='templateNameMap.get(informationCriteria.key)'>
                          </ng-container>
                        </div>
                      </div>
                    </label>
                    <ng-container [ngSwitch]="informationCriteria.key">
                      <ng-container *ngSwitchCase="'ESTIMATED_MONTHLY_COMSUMPTION'">
                        <div *ngIf="isEstimatedMonthlyConsumptionKwhWarningVisible" class="text text-danger">
                          {{informationCriteriaWarning}}
                        </div>
                        <div class="form-group row">
                          <div class="col-xl">
                            <input class="form-control" type="text"
                              placeholder="{{estimatedMonthlyConsumtionPlaceholder}}"
                              formControlName="{{controlFormNameMap.get(informationCriteria.key + '_MWH')}}" />
                          </div>
                          <span>MWh</span>
                          <div class="col-xl">
                            <input class="form-control" type="text"
                              placeholder="{{estimatedMonthlyConsumtionPlaceholder}}"
                              formControlName="{{controlFormNameMap.get(informationCriteria.key + '_KWH')}}" />
                          </div>
                          <span>kWh</span>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'SUPPLY_PRICE'">
                        <div *ngIf="isSupplyPriceWarningVisible" class="text text-danger">
                          {{informationCriteriaWarning}}
                        </div>
                        <div class="form-group row">
                          <div class="col-xl">
                            <input class="form-control" type="text" placeholder="{{supplyPricePlaceholder}}"
                              formControlName="{{controlFormNameMap.get(informationCriteria.key + '_LEI_MWH')}}" />
                          </div>
                          <span>lei/MWh</span>
                          <div class="col-xl">
                            <input class="form-control" type="text" placeholder="{{supplyPricePlaceholder}}"
                              formControlName="{{controlFormNameMap.get(informationCriteria.key + '_LEI_KWH' )}}" />
                          </div>
                          <span>lei/kWh</span>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="'INVOICE_SUBSCRIPTION'">
                        <div *ngIf="isInvoiceSubscriptionWarningVisible" class="text text-danger">
                          {{informationCriteriaWarning}}
                        </div>
                        <input class="form-control" type="text" placeholder="{{invoiceSubscriptionPlaceholder}}"
                          formControlName="{{controlFormNameMap.get(informationCriteria.key)}}" />
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <div class="center-item">
              <button type="button" class="btn btn-primary" (click)="onSubmit('', results)">Cauta</button>
            </div>
            <ng-container *ngIf="messageError">
              <div class="center-item card-header">
                <div [ngClass]="onDisplayMessageError(messageError)" style="font-weight:bold"
                  [innerHtml]="messageError">
                </div>
              </div>
            </ng-container>
            <p align="justify" [innerHtml]="noteFieldsMandatoryToComplete"></p>
            <p align="justify" *ngIf="isNaturalElectricitySupplyComparisonForm">{{electricComparatorNote}}</p>
          </form>
        </div>

        <div class="container-fluid" #results>
          <ng-container *ngIf="gasComparatorResults && gasComparatorResults.length > 0 && formSubmitAttempt">
            <app-gas-comparator-table [gasComparatorResults]="gasComparatorResults" [comparatorForm]="comparatorForm">
            </app-gas-comparator-table>
          </ng-container>
          <ng-container *ngIf="electricComparatorResults && electricComparatorResults.length > 0 && formSubmitAttempt">
            <app-electric-comparator-table [electricComparatorResults]="electricComparatorResults"
              [comparatorForm]="comparatorForm" (searchEvent)="search($event)">
            </app-electric-comparator-table>
          </ng-container>
          <p align="justify" [innerHtml]="footerTextResults"></p>
        </div>
      </div>
    </div>
  </div>

  <ng-template #finalClientTypeInfo>
    <p><b>95% dintre clienții finali sunt clienţi casnici</b> <br><br>Alegeți în funcţie de utilizarea gazelor
      naturale la
      locul de consum:</p>
    <p>- <b>sunteți client casnic</b> dacă doriți să cumpărați gaze naturale pentru consumul casnic propriu <b>(de
        ex.
        prepararea hranei sau încălzirea locuinței)</b></p>
    <p>- <b>sunteți client noncasnic</b> dacă doriți să cumpărați gaze naturale ce nu sunt destinate consumului
      casnic
      propriu <b>(de ex. încălzirea spațiului destinat unei activități lucrative sau folosit în procese de
        producție)</b>
    </p>
  </ng-template>

  <ng-template #connectionMethodInfo>
    <p><b>99,9% dintre clienții finali sunt racordați în sistemul de distribuție</b><br><br>Alegeți modalitatea de
      racordare în funcţie de obiectivul din sectorul gazelor naturale la care este racordat locul dumneavoastră
      de
      consum.</p>
  </ng-template>

  <ng-template #annualConsumptionCategoryInfo>
    <p><b>99,7% dintre clienții finali au un consum anual de până la 280 MWh</b><br><br>Alegeți tranșa în care se
      încadrează consumul anual de gaze naturale realizat la locul dumneavoastră de consum.<br>Informaţii privind
      istoricul de consum înregistrat pentru respectivul loc de consum pot fi obținute de la furnizorul şi/sau
      operatorul
      dumneavoastră, precum şi prin intermediul facturii şi/sau al documentelor anexate acesteia.</p>
  </ng-template>

  <ng-template #unitSupplyPriceTypeInfo>
    <p><b>99,9% dintre clienții finali au serviciile reglementate de distribuţie și transport incluse în
        preț</b><br><br>În funcţie de modalitatea în care se dorește să se realizeze furnizarea gazelor naturale,
      acesta
      poate fi:<br><b>a) cu servicii reglementate incluse</b> - situaţie în care preţul de furnizare a gazelor
      naturale
      include pe lângă prețul gazelor naturale şi tarifele reglementate de ANRE aferente serviciilor de transport
      şi/sau
      distribuţie, necesare pentru vehicularea gazelor naturale până la locul dumneavoastră de consum, fiind
      responsabilitatea furnizorului să încheie un contract de distribuţie şi/sau un contract de transport, după
      caz, cu
      titularul/titularii licenţei/licenţelor de operare a conductei/sistemului de alimentare aferent;<br><b>b)
        fără
        servicii reglementate incluse</b> - situaţie în care preţul de furnizare a gazelor naturale include numai
      prețul
      gazelor naturale. În vederea vehiculării gazelor naturale până la locul dumneavoastră de consum, încheierea
      contractelor pentru prestarea serviciilor de transport şi/sau distribuţie, vă revine dumneavoastră, iar
      preţul de
      furnizare nu include tarifele reglementate de ANRE aferente acestor servicii.</p>
  </ng-template>

  <ng-template #countyInfo>
    <p>Selectați județul în care se află locul de consum pentru care doriți sa încheiați un contract de furnizare
    </p>
  </ng-template>

  <ng-template #cityInfo>
    <p>Selectați localitatea în care se află locul de consum pentru care doriți sa încheiați un contract de
      furnizare</p>
  </ng-template>

  <ng-template #additionalCriteriaInfo>
    <p>Selectați opţiunea corespunzătoare în funcție de ofertele pe care doriți sa le afișeze comparatorul și
      criteriile
      care corespund cel mai bine nevoilor dumneavoastră</p>
  </ng-template>

  <ng-template #offerDateInfo>
    <p>Se selectează data de la care se dorește aplicarea ofertei.</p>
  </ng-template>

  <ng-template #gasPriceTypeInfo>
    <p>Notă: A nu se confunda prețul de achiziție a GN cu preţul de furnizare a GN sau prețul final, care se poate
      modifica fără notificare odată cu modificarea tarifelor reglementate.</p>
  </ng-template>

  <ng-template #subscriptionInfo>
    <p>- da: comparatorul va afișa ofertele furnizorilor care au inclus o componentă fixă (abonament) (lei/zi)</p>
    <p>- nu: comparatorul va afișa ofertele furnizorilor care nu au inclus o componentă fixă (abonament) (lei/zi)
    </p>
  </ng-template>

  <ng-template #comparisonInformationInfo>
    <p>Completarea informațiilor despre Consumul lunar estimat, Prețul de furnizare din contractul actual și
      Componenta
      fixă (abonament) din contractul actual vă va furniza în coloanele: Rezultat comparație preţ oferta-tip/preţ
      actual
      (include si valoarea abonamentului lunar) (%), Valoare factură estimată conform ofertei-tip (include si
      valoarea
      abonamentului lunar) (cu TVA, si acciza, după caz) (lei) și Economie/Cost suplimentar lunar (lei) din tabelul de
      rezultate,
      informaţii comparative utile în alegerea ofertei care corespunde cel mai bine nevoilor dumneavoastră.
      Rezultatul
      comparației ține cont și de valoarea lunară a componentei fixe (abonamentului), dacă există. </p>
  </ng-template>

  <ng-template #guaranteesInfo>
    <p>- cu garanții: comparatorul va afișa ofertele furnizorilor care pot solicita garanții financiare;</p>
    <p>- fără garanții: comparatorul va afișa ofertele furnizorilor care nu solicită garanții financiare;</p>
    <p>Garanția financiară reprezintă un instrument financiar constituit în vederea garantării obligațiilor
      comerciale
      asumate de către clientul final în relația cu furnizorul.</p>
  </ng-template>

  <ng-template #estimatedMonthlyConsumptionInfo>
    <p><b>Introduceți consumul din factura curentă sau un consum estimat, în cazul în care nu aveți informații cu
        privire
        la valoarea acestuia.</b></p>
    <p><b>Câmpul este completat implicit cu o valoare de 1000 kWh,</b> astfel încât să poată fi realizată o
      comparație în
      funcție de valoarea estimată a facturii.</p>
    <p>În cazul în care nu doriți o astfel de comparație, acest câmp poate fi lăsat necompletat, prin ștergerea
      valorii
      implicite, caz în care comparația se va realiza în funcție de prețul de furnizare. </p>
  </ng-template>

  <ng-template #clientTypeInfo>
    <p><b>Casnic - </b>clientul care cumpără energie electrică pentru propriul consum casnic, excluzând consumul
      pentru
      activităţi comerciale sau profesionale</p>
    <br>
    <p><b>Noncasnic - </b>orice persoană fizică sau juridică ce cumpără energie electrică ce nu este pentru
      propriul
      consum casnic; această categorie include şi producători de energie electrică, clienţii industriali,
      întreprinderile
      mici şi mijlocii, operatori economici şi clienţii angro; </p>
  </ng-template>

  <ng-template #offerTypeInfo>
    <p><b>Oferte concurențiale - </b>se adresează tuturor clienților; relația contractuală se desfășoară pe baza
      unui
      contract negociat între părți, contractul putând fi încheiat de către client cu orice furnizor de energie
      electrică.
    </p>
    <br>
    <p><b>Oferte serviciu universal - </b>se adresează clienților casnici iar relația contractuală se desfășoară
      în baza
      unui contract standard, contractul putând fi încheiat de către client cu orice furnizor de energie electrică
      care
      are încheiate contracte în piaţa concurenţială cu clienţi casnici</p>
  </ng-template>

  <ng-template #currentBillConsumptionInfo>
    <p>Se introduce consumul din factura curentă pentru care se dorește realizarea unei comparații. În acest caz
      pentru a
      se putea realiza comparația corectă este necesar să se completeze și valoarea din câmpul „Valoarea facturii
      curente
      pentru comparație” preluată din aceeași factură din care se utilizează consumul de energie electrică.</p>
    <br>
    <p>Se introduce un consum estimat în cazul în care nu se dorește o comparație cu valoarea facturii curente sau
      nu
      există informația privind valoarea acesteia.</p>
    <br>
    <p>Câmpul este completat automat cu o valoare de 100 KWh, care reprezintă un consum mediu lunar în cazul
      clienților
      casnici, astfel încât să poată fi calculată valoarea estimată a facturii.</p>
  </ng-template>

  <ng-template #voltageLevelInfo>
    <p>Nivelul de tensiune la care este alimentat locul de consum. În cazul clienților casnici majoritatea
      locurilor de
      consum sunt alimentate pe joasă tensiune. Valoarea din acest câmp este setată pe nivelul de joasă tensiune.
    </p>
  </ng-template>

  <ng-template #priceTypeInfo>
    <p><b>Nediferențiat - </b>prețul energiei electrice este același pentru fiecare oră.</p><br>
    <p><b>Diferențiat - </b>prețul energiei electrice este diferit în funcție de ore. Se stabilesc prețuri
      diferite pentru
      orele de zi și orele de noapte</p>
  </ng-template>

  <ng-template #currentInvoiceValueInfo>
    <p>Se introduce valoarea în lei a consumului de energie electrică din factura emisă de actualul furnizor de
      energie
      electrică. Se va avea în vedere cea mai recentă factură pentru a avea tarifele reglementate pentru servicii
      la
      aceleași valori cu cele din comparator.</p>
  </ng-template>

  <ng-template #productTypeInfo>
    <p><b>Preț fix - </b>prețul rămâne neschimbat pe toată perioada de aplicare a ofertei comunicate de furnizor
    </p><br>
    <p><b>Preț variabil - </b>prețul se poate modifica în interiorul periodei de aplicare a ofertei.</p>
  </ng-template>

  <ng-template>
    Vă recomandam să completați si acest câmp pentru a obține informaţii comparative despre preţ și costuri in
    tabelul de
    rezultate
  </ng-template>

  <ng-template #gasPriceTypeOption1Info>
    <p>Oferta ”cu preț Fix” - o oferta care garantează ca preţul de achiziţie a GN nu se va modifica pe o perioada
      de timp
      data</p>
  </ng-template>

  <ng-template #gasPriceTypeOption2Info>
    <p> Oferta ”cu preț Variabil” - o oferta in care preţul de achiziţie a GN poate fi modificat oricând</p>
  </ng-template>

  <ng-template #gasPriceTypeOption3Info>
    <p>Oferta ”cu preț Mixt” - o oferta care are o perioada cu preț fix și o perioadă cu preț variabil, pentru
      preţul de
      achiziţie a GN</p>
  </ng-template>

  <ng-template #gasPriceTypeOption4Info>
    <p>Oferta ”cu preț Variabil bazat pe preturi SPOT" - un pret variabil bazat pe piaţa engros de vânzare a
      produselor pe
      termen scut (SPOT)</p>
  </ng-template>

  <ng-template #gasPriceTypeOption5Info>
    <p>Oferta ”cu preț Variabil bazat pe preturi ANGRO" - un pret variabil bazat pe pretul mediu de vanzare al
      produselor
      altele deczat cele SPOT, pe piaţa engros</p>
  </ng-template>

  <ng-template #gasPriceTypeOption6Info>
    <p>Oferta ”cu preț Maxim" - o oferta care garantează ca preţul plătit pe unitatea de energie nu poate creste
      peste o
      valoare stabilita, pentru o perioada de timp data, dar poate sa scadă - de obicei pentru acesta siguranţa
    </p>
  </ng-template>

  <ng-template #gasPriceTypeOption7Info>
    <p>Oferta ”cu preț bazat pe Index Variabil" - pretul este legat de un indice al pietei (de exemplu: Retail
      Price
      Index(RPI) - Indicele preturilor produselor de consum cu amănuntul)</p>
  </ng-template>

  <ng-template #earlyTerminationPenaltiesInfo>
    <b>Cu penalitati</b> la rezilierea de catre client a contractului, inainte de ajungerea la termen a
    contractului.<br>
    <b>Fara penalitati</b> la rezilierea de catre client a contractului, inainte de ajungerea la termen a
    contractului.
  </ng-template>

  <ng-template #offerTypeOption2Info>
    Oferta ”Dublă GAZE si ENERGIE” - o ofertă al cărei preț depinde de încheierea unui contract si pentru energie
    electrică
  </ng-template>
